import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import VueMarkdown from 'vue-markdown';
import Loading from '@/components/Loading.vue';
import BackButton from '@/components/BackButton.vue';
const deploymentsModule = namespace('deployments');
let StarshipDeploymentDetails = class StarshipDeploymentDetails extends Vue {
    created() {
        this.fetchDeployments();
    }
    get title() {
        return this.deploymentName + ' | Starships' + Vue.prototype.$titleSuffix;
    }
    get deploymentData() {
        return this.deployments.find(({ name }) => name === this.deploymentName);
    }
};
__decorate([
    deploymentsModule.State
], StarshipDeploymentDetails.prototype, "deployments", void 0);
__decorate([
    deploymentsModule.Action
], StarshipDeploymentDetails.prototype, "fetchDeployments", void 0);
__decorate([
    Prop(String)
], StarshipDeploymentDetails.prototype, "deploymentName", void 0);
StarshipDeploymentDetails = __decorate([
    Component({
        components: {
            VueMarkdown,
            BackButton,
            Loading
        }
    })
], StarshipDeploymentDetails);
export default StarshipDeploymentDetails;
